import { api } from "./api";

const PAUSE_MS = 2500;
let flute = null;
let voice = null;
let gap = null;
let runId = 0;
const cache = new Map();

async function voiceUrl(text) {
  if (cache.has(text)) return cache.get(text);
  const { data } = await api.get("/tts/affirmation", { params: { text }, responseType: "blob" });
  const url = URL.createObjectURL(data);
  cache.set(text, url);
  return url;
}

export async function playAffirmations(texts, cb, opts) {
  stopAffirmations();
  const id = ++runId;
  flute = new Audio("/audio/pan_flute.mp3");
  flute.loop = true;
  flute.volume = opts.music;
  flute.play().catch(() => {});

  const playAt = async (i) => {
    if (id !== runId) return;
    if (i >= texts.length) {
      if (opts.loop && texts.length) i = 0;
      else {
        stopAffirmations();
        cb.onDone();
        return;
      }
    }
    let url;
    try {
      url = await voiceUrl(texts[i]);
    } catch {
      if (id === runId) {
        stopAffirmations();
        cb.onError("download");
      }
      return;
    }
    if (id !== runId) return;
    voice = new Audio(url);
    voice.onplaying = () => cb.onIndex(i);
    voice.onended = () => {
      gap = setTimeout(() => playAt(i + 1), PAUSE_MS);
    };
    voice.play().catch(() => cb.onError("playback"));
  };
  playAt(0);
}

export function setMusicVolume(v) {
  if (flute) flute.volume = v;
}

export function stopAffirmations() {
  runId++;
  clearTimeout(gap);
  voice?.pause();
  flute?.pause();
  voice = null;
  flute = null;
}
